import { cn } from "@/lib/utils";
import { forwardRef } from "react";
import { Button } from "../ui/button";

type ToggleButtonProps = React.ComponentProps<typeof Button> & {
  active: boolean;
};

export const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(
  ({ active, className, ...props }, ref) => {
    return (
      <div className="relative">
        <Button
          className={cn({ "opacity-25": !active }, className)}
          {...props}
          ref={ref}
        />
        {!active && (
          <div
            className={cn(
              "absolute top-1/2 left-1/2 -translate-x-[50%] -translate-y-[50%]",
              "h-[2px] w-[16px] -rotate-45",
              "bg-foreground/25 border-background-1 box-content border-1",
              "pointer-events-none",
            )}
          />
        )}
      </div>
    );
  },
);
